import { useEffect, useState } from 'react'
import { GlitimeMark } from '../glitime/Mark.js'
import { register, sassLine } from '../sass/engine.js'
import { useSassOnce } from '../sass/useSassOnce.js'
import { type SyncState, subscribeSync, syncNow } from '../sync/engine.js'

/**
 * Only speaks up when something is wrong or pending. A permanent status bar
 * would spend the screen's most valuable row saying "fine" nearly always.
 */
export function SyncBanner() {
  const [state, setState] = useState<SyncState | null>(null)

  useEffect(() => subscribeSync(setState), [])

  const offline = state?.status === 'offline'
  const failed = state?.status === 'error'
  const line = useSassOnce(offline ? 'offline' : failed ? 'error' : null, () =>
    offline
      ? (sassLine('error_offline', {}) ?? 'Neprisijungta')
      : (sassLine('error_sync', {}) ?? 'Sinchronizavimas nepavyko'),
  )

  if (!state || line == null) return null

  return (
    <button
      type="button"
      onClick={() => void syncNow()}
      className="flex shrink-0 items-center justify-center gap-2 border-b border-line bg-raised px-4 py-1.5 text-xs text-dim"
    >
      <span className="size-1.5 rounded-full bg-warn" aria-hidden="true" />
      {/* Only in her own register — the dry one is the app talking, and the
          mark would be claiming a voice that toggle deliberately turned off. */}
      {register() === 'sassy' && <GlitimeMark size={14} alive={false} station="sync" />}
      {line}
      {state.pendingCount > 0 && <span className="tnum">· {state.pendingCount} laukia</span>}
    </button>
  )
}
